"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.initialState = void 0;
const api_1 = require("../../utils/api");
exports.initialState = {
    broadcastsAvailabilityMapping: {},
    broadcasts: {},
    fetchItems: api_1.requestInitialState,
    fetchItem: api_1.requestInitialState,
};
//# sourceMappingURL=constants.js.map